import type { Settings } from './types.js';

/**
 * The online room options bag built from the host's Settings. The server's
 * `ruleSetFromRoomOptions` keeps only what applies to the room's variant, so
 * every rule option is always sent.
 */
export function roomRuleOptions(settings: Settings): Record<string, unknown> {
  return {
    pointGoal: settings.pointGoal,
    opening13: settings.goatOpening13,
    baldFinish: settings.goatBaldFinish,
  };
}
